import { NotificationStates } from '../constants/notifications/states';

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectNotificationError = state => state.common[NotificationStates.NotificationError];
export const selectNotificationInfo = state => state.common[NotificationStates.NotificationInfo];
export const selectNotificationSuccess = state => state.common[NotificationStates.NotificationSuccess];
export const selectNotificationWarning = state => state.common[NotificationStates.NotificationWarning];
